export enum NavbarTypeEnum {
  SIDE_MENU = 'SIDE_MENU',
  TOP_MENU = 'TOP_MENU',
  MINI_SIDE_MENU = 'MINI_SIDE_MENU',
}
